import { ClickAndCollectCountdownUI } from "./ClickAndCollectCountdownUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "@/utils/product/ensureIsActive.ts";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { isBetweenDates } from "@/utils/date/isBetweenDates.ts";
const CLICK_AND_COLLECT_DMS_CODE = "187";

const hideIfDates: [string, string][] = [
  ["2024-12-23", "2024-12-26"],
  ["2024-12-31", "2024-12-31"],
];

export function ClickAndCollectCountdown({
  product,
}: Pick<StandardProps, "product">) {
  const { variant, isSelected } = useVariant(product);
  if (product.__typename !== "SimpleProduct") return null;
  const activeVariant = ensureIsActiveVariant(variant);
  const isShipFromStore = variant.availability?.shipFromStore === true;
  if (!activeVariant) return null;
  if (isShipFromStore && isSelected) return null;

  if (Array.isArray(hideIfDates)) {
    const shouldHideWithinDates = hideIfDates.some(([startTime, endTime]) =>
      isBetweenDates(startTime, endTime),
    );

    if (shouldHideWithinDates) {
      return null;
    }
  }

  const { availability } = activeVariant;

  if (
    !availability.availableToOrder ||
    availability.futureAvailability ||
    availability.preOrder
  )
    return null;

  const clickAndCollectFulfilmentOption =
    product.fulfilmentOptions.available.find(
      (option) => option.aliases?.dmsId === CLICK_AND_COLLECT_DMS_CODE,
    );

  if (!clickAndCollectFulfilmentOption) return null;

  return (
    <ClickAndCollectCountdownUI
      orderByLocalTimeToday={
        clickAndCollectFulfilmentOption.earliestFulfilment
          ?.orderByLocalTimeToday
      }
      collectFromLocalTimeTomorrow={
        clickAndCollectFulfilmentOption.earliestFulfilment
          ?.collectFromLocalTimeTomorrow
      }
      duration={3}
    />
  );
}
